// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
// SPREAD INDICATOR
export var TerceraChartSpreadType;
(function (TerceraChartSpreadType) {
    TerceraChartSpreadType[TerceraChartSpreadType["Area"] = 0] = "Area";
    TerceraChartSpreadType[TerceraChartSpreadType["Lines"] = 1] = "Lines";
    TerceraChartSpreadType[TerceraChartSpreadType["LinesWithPrices"] = 2] = "LinesWithPrices";
    TerceraChartSpreadType[TerceraChartSpreadType["None"] = 3] = "None";
})(TerceraChartSpreadType || (TerceraChartSpreadType = {}));
export function getTerceraChartSpreadTypeKey(value) {
    switch (value) {
        case TerceraChartSpreadType.Area:
            return 'property.SpreadType.Area';
        case TerceraChartSpreadType.Lines:
            return 'property.SpreadType.Line';
        case TerceraChartSpreadType.LinesWithPrices:
            return 'property.SpreadType.LineWithLabel';
        case TerceraChartSpreadType.None:
            return 'property.SpreadType.None';
        default:
            return '';
    }
}
